module.exports = __webpack_public_path__ + "static/knittedblueteddy1-a962c9fb29cbd8852b6e956df132fe07.jpeg";